/**
 * Internationalization constants — frontend single source of truth.
 *
 * Mirrors backend core/i18n/__init__.py. Adding a new language requires
 * updating SUPPORTED_LOCALES here and in the backend constant (OCP).
 */

export const SUPPORTED_LOCALES = [
  "en",
  "km",
  "hmn",
  "fil",
  "es",
  "lo",
  "vi",
  "zh-CN",
  "th",
  "ne",
  "ium",
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "en";

export const LOCALE_NATIVE_NAMES: Record<SupportedLocale, string> = {
  en: "English",
  km: "ភាសាខ្មែរ",
  hmn: "Hmoob",
  fil: "Filipino",
  es: "Español",
  lo: "ພາສາລາວ",
  vi: "Tiếng Việt",
  "zh-CN": "中文（简体）",
  th: "ภาษาไทย",
  ne: "नेपाली",
  ium: "Iu Mienh",
};

export const RTL_LOCALES: ReadonlySet<string> = new Set<string>();

export function isRtl(locale: string): boolean {
  return RTL_LOCALES.has(locale);
}
